import {
  Center, Heading, Text,
  Icon, HStack,
  Box,
  Flex,
  Spacer,
  Grid,
  Divider
} from "@chakra-ui/react";
import { FaForward } from "react-icons/fa6";
import { NavLink } from "react-router-dom";

type DashboardMenuProps = {
  targets: any[];
};

export default function DashboardMenu({ targets }: DashboardMenuProps) {


  const colors = ["red", "orange", "yellow", "green", "teal", "blue", "pink"];


  return (
    <Grid templateColumns='repeat(4, 1fr)' gap={5} width={"100%"}>
      {targets?.map((target, index) => (
        <NavLink key={index} to={`/targets/${target.index}`} state={target}>
          <Flex backgroundColor={`${colors[index]}.300`} flexDirection={"column"}
            shadow={"base"}
            _hover={{
              opacity: 0.9,
              shadow: "xl",
              boxShadow: "lg",
            }}
            borderRadius={"lg"}
            className="dashboard-menu-item"
          >
            <Box textAlign={"center"} p={1}>
              <Text fontWeight={"normal"} textTransform={"uppercase"} height={"100%"} display={"block"}>
                OBIETTIVO {target.index}
              </Text>
              <Divider borderColor={`${colors[index]}.200`} />
            </Box>
            <Box>
              <Text fontWeight={"bold"} textTransform={"uppercase"}>
                {target.title}
              </Text>
            </Box>
          </Flex>

        </NavLink>
      ))}

      <NavLink key={-1} to={`/targets`}>

        <Flex backgroundColor={"gray.300"} alignItems={"center"} flexDirection={"column"}
          shadow={"base"}
          _hover={{
            opacity: 0.9,
            shadow: "xl",
            boxShadow: "md",
          }}
          borderRadius={"md"}
          className="dashboard-menu-item"
        >
          <Box textAlign={"center"} p={1}>
            <Text fontWeight={"bold"} textTransform={"uppercase"} height={"100%"} display={"block"}>
              LISTA OBIETTIVI
            </Text>
            <Divider borderColor={`gray.200`} />
          </Box>

          <Box>
            <Text fontWeight={"bold"} textTransform={"uppercase"} height={"100%"} display={"block"} fontSize={"x-large"}>
              <Icon as={FaForward} p={0} m={0}/>
            </Text>
          </Box>
        </Flex>
      </NavLink>
    </Grid>
  );
}
